import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import NewsList from '../../news/news-list';

class Projects extends Component {
  render() {
    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Інфоцентр</Link></li>
          <li><Link to="/infocenter/projects">Проекти та програми</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Проекти та програми</h2>
            <NewsList tag={1} url="infocenter/projects"/>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default withRouter(Projects);



// WEBPACK FOOTER //
// ./src/system/information-center/projects/index.js